var _line, _g, _g2, _g3, _rect, _rect2, _g4, _rect3, _rect4, _line2, _line3, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewFrameSizeArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "540px",
    height: "650px",
    viewBox: "0 0 540 650",
    enableBackground: "new 0 0 540 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 641.6,
    x2: 460,
    y2: 641.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M477.9,648v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H477.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M488.7,648v-13.3h1.7v11.9h6.2v1.5H488.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M499.1,644.8c-0.5-1-0.8-2.2-0.8-3.5c0-1.3,0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5c0.6,1,0.8,2.2,0.8,3.5c0,1.3-0.3,2.5-0.8,3.5c-0.6,1-1.3,1.9-2.4,2.5 c-1,0.6-2.2,0.9-3.5,0.9s-2.4-0.3-3.5-0.9C500.4,646.7,499.6,645.9,499.1,644.8z M500,641.3c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9 c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7c0.8-0.5,1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9 c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5C500.4,638.4,500,639.7,500,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M514.4,644.8c-0.5-1-0.8-2.2-0.8-3.5c0-1.3,0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5c0.6,1,0.8,2.2,0.8,3.5c0,1.3-0.3,2.5-0.8,3.5c-0.6,1-1.3,1.9-2.4,2.5 c-1,0.6-2.2,0.9-3.5,0.9s-2.4-0.3-3.5-0.9C515.7,646.7,514.9,645.9,514.4,644.8z M515.3,641.3c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9 c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7c0.8-0.5,1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9 c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5C515.7,638.4,515.3,639.7,515.3,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M529.4,648v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3H531v5.3H529.4z M531,641.2h3.5 c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8c0-0.8-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7H531V641.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 176.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 199.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 82.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 405.3,
    y: 79.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 79.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 390.9,
    y1: 120.5,
    x2: 68.5,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "388.3,111.6 403.8,120.5 388.3,129.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "71.2,111.6 55.6,120.5 71.2,129.5  "
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 380.8,
    y: 69.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 69.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 405.3,
    y1: 89.8,
    x2: 405.3,
    y2: 131.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 54.7,
    y1: 89.8,
    x2: 54.7,
    y2: 131.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 450.5,110.8 460,101.2 0.3,101.2 9.2,110.8 449.2,110.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.1,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewFrameSizeArc);
export default __webpack_public_path__ + "static/media/help_new_FrameSize_arc.88489e415617ab3ac0adf1e2b3c440d8.svg";
export { ForwardRef as ReactComponent };